import { Theme, ThemeBreakpoints, ThemeColor, ThemeColors, ThemeTypographies } from "./types"

const white: ThemeColor = {
  main: '#F7F7F7',
  light: '#FFFFFF',
  dark: '#ebebeb',
  text: '#2B2C32'
}

const black: ThemeColor = {
  main: '#2B2C32',
  light: '#232429',
  dark: '#000000',
  text: '#FFFFFF'
}

const red: ThemeColor = {
  main: '#E1251B',
  dark: '#c1211b',
  text: '#FFFFFF',
  hover: '#c1211b'
}

const purple: ThemeColor = {
  main: '#3D1952',
  text: '#FFFFFF'
}

const teal: ThemeColor = {
  main: '#007A85',
  text: '#FFFFFF',
  dark: '#00646d',
  light: '#00828E',
  hover: '#00828E'
}

const shade = [
  "#000000",
  "#181818",
  "#232429",
  "#373a47",
  "#6d6d6d",
  "#7C7F83",
  "#b4b7bd",
  "#d8d8d8",
  "#e8e9eb",
  "#ebedeb",
  "#ffffff",
]

const colors: ThemeColors = {
    // define all colors
    colorMode: 'light',
    base: white,
    primary: black,
    secondary: red,
    tertiary: purple,
    accent: teal,
    shade
  };

  
  const breakpoints: ThemeBreakpoints = {
    xs: 0,
    sm: 374,
    md: 678,
    lg: 960,
    xl: 1278,
  };
  
  const typography: ThemeTypographies = {
    // define all typography
    fontFamily: {
      noirPro: '"Noir Pro", Arial, Helvetica, sans-serif',
    },
    h1: {
      fontSize: {
        xs: '32px',
        sm: '38px',
        md: '66px',
        lg: '66px',
        xl: '66px',
      },
      lineHeight: {
        xs: '46px',
        sm: '46px',
        md: '78px',
        lg: '78px',
        xl: '78px',
      },
      fontWeight: '600',
    },
    h2: {
      fontSize: {
        xs: '32px',
        sm: '32px',
        md: '48px',
        lg: '48px',
        xl: '48px',
      },
      lineHeight: {
        xs: '40px',
        sm: '40px',
        md: '58px',
        lg: '58px',
        xl: '58px',
      },
      fontWeight: '600',
    },
    h3: {
      fontSize: {
        xs: '24px',
        sm: '24px',
        md: '36px',
        lg: '36px',
        xl: '36px',
      },
      lineHeight: {
        xs: '36px',
        sm: '36px',
        md: '44px',
        lg: '44px',
        xl: '44px',
      },
      fontWeight: '600',
    },
    h4: {
      fontSize: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      lineHeight: {
        xs: '36px',
        sm: '36px',
        md: '36px',
        lg: '36px',
        xl: '36px',
      },
      fontWeight: '500',
    },
    h5: {
      fontSize: {
        xs: '18px',
        sm: '18px',
        md: '18px',
        lg: '18px',
        xl: '18px',
      },
      lineHeight: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      fontWeight: '600',
    },
    h6: {
      fontSize: {
        xs: '18px',
        sm: '18px',
        md: '18px',
        lg: '18px',
        xl: '18px',
      },
      lineHeight: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      fontWeight: '600',
    },
    body1: {
      fontSize: {
        xs: '18px',
        sm: '18px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      lineHeight: {
        xs: '24px',
        sm: '24px',
        md: '28px',
        lg: '28px',
        xl: '28px',
      },
      fontWeight: '400',
    },
    body2: {
      fontSize: {
        xs: '16px',
        sm: '16px',
        md: '18px',
        lg: '18px',
        xl: '18px',
      },
      lineHeight: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      fontWeight: '400',
    },
    body3: {
      fontSize: {
        xs: '14px',
        sm: '14px',
        md: '16px',
        lg: '16px',
        xl: '16px',
      },
      lineHeight: {
        xs: '20px',
        sm: '20px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      fontWeight: '400',
    },
    legal: {
      fontSize: {
        xs: '12px',
        sm: '12px',
        md: '12px',
        lg: '12px',
        xl: '12px',
      },
      lineHeight: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      fontWeight: '400',
    },
    button: {
      fontSize: {
        xs: '14px',
        sm: '14px',
        md: '14px',
        lg: '14px',
        xl: '14px',
      },
      lineHeight: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
        xl: '24px',
      },
      fontWeight: '600',
    },
  };
  
  const defaultLightTheme = new Theme(colors, breakpoints, typography);
  
  export default defaultLightTheme;